<template>
  <div>
    <top />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'nuxt-property-decorator';

import TrialRegistrationDialog from '@/components/dialog/trial-registration-dialog.vue';
import TopBanner from '@/components/top-banner.vue';
import Top from '@/components/renewal/top.vue';
import 'design-system/tokens';

@Component({
  components: {
    TrialRegistrationDialog,
    TopBanner,
    Top,
  },
})
export default class Index extends Vue {}
</script>

<style lang="scss">
@import '@/../node_modules/vuetify/src/styles/styles.sass';
</style>
